export default __webpack_public_path__ + "static/media/wag-text-only-logo.d48efade.svg";